import { useAuth } from "@/hooks/useAuth";
import AppHeader from "@/components/AppHeader";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import BoardsUploadWorkflow from "@/components/BoardsUploadWorkflow";
import { FileText, Download } from "lucide-react";

// Live exports of the Google Docs — editing a Doc updates the download
// immediately, no redeploy. The Docs must stay "anyone with the link can view".
const GUIDES: Array<{ label: string; href: string }> = [
  {
    label: "Greenlit Patient Board",
    href: "https://docs.google.com/document/d/1grBBDU9e0jgMpnV1cIPmf0GuMycUSrFk/export?format=pdf",
  },
  {
    label: "Weekly Patient Permissions Board 2026",
    href: "https://docs.google.com/document/d/1OAdpXzF7hf7g2pBwT-RC8iVa2zfeNGgl/export?format=pdf",
  },
];

export default function Boards() {
  useAuth({ redirectOnUnauthenticated: true });

  return (
    <div className="min-h-screen bg-background">
      <AppHeader />

      <main className="container py-8">
        <div className="max-w-2xl mx-auto flex flex-col gap-6">
          <div>
            <h2 className="text-2xl font-semibold text-foreground">Boards</h2>
            <p className="mt-1 text-muted-foreground">
              Convert weekly appointment PDFs into clean CSVs and drop them straight into the
              location's Google Drive.
            </p>
          </div>

          <BoardsUploadWorkflow />

          {/* Downloadable how-to PDFs for the Boards workflows. */}
          <Card>
            <CardHeader className="pb-4">
              <CardTitle className="text-xl">Guides</CardTitle>
              <CardDescription>How-to docs for the Boards workflows.</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {GUIDES.map((g) => (
                  <Button
                    key={g.href}
                    asChild
                    className="justify-start h-auto py-3 px-3 text-left whitespace-normal bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-900/40 dark:text-green-300 dark:hover:bg-green-900/60"
                  >
                    <a href={g.href} target="_blank" rel="noopener noreferrer">
                      <FileText className="w-4 h-4 mr-2 flex-shrink-0 opacity-80" />
                      <span className="flex-1 text-sm leading-snug">{g.label}</span>
                      <Download className="w-4 h-4 ml-2 flex-shrink-0 opacity-80" />
                    </a>
                  </Button>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
